import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateModalEnum } from '../../enums/modal.enum';
import { ButtonTypesEnum } from '../../interfaces/button';
import { ModalComponent } from '../modal/modal.component';
import { ButtonComponent } from '../button/button.component';
import { HandleScreenService } from '../../services/handle-screen.service';

@Component({
  selector: 'ui-warning-modal',
  standalone: true,
  imports: [CommonModule, ModalComponent, ButtonComponent],
  templateUrl: './warning-modal.component.html',
  styleUrl: './warning-modal.component.scss',
})
export class WarningModalComponent {
  @Input() openWarningModal: boolean = false;
  @Output() closeWarningModal: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  public templateModalEnum = TemplateModalEnum;
  public buttonType = ButtonTypesEnum;

  get isMobile(): boolean {
    return this.handleScreenService.isMobile();
  }

  constructor(private handleScreenService: HandleScreenService) {}

  closeModal(toggle: boolean): void {
    this.closeWarningModal.emit(toggle);
  }
}
